<div class="modal in" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{data.title}}
                </h4>
                <button type="button" (click)="no()" class="btn-close" data-dismiss="modal"
                    [attr.aria-label]="'COMMON.close' | translateHs "></button>
            </div>
            <div class="modal-body" style="overflow-y:auto">
                <p class="fw-bold h6">{{data.message}}</p>
                <p class="h6 small">{{data.note}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="yes()" [title]="'COMMON.yes' | translateHs"
                    data-dismiss="modal">{{'COMMON.yes' |
                    translateHs}}</button>
                <button type="button" class="btn btn-secondary compositions-btn-cancel"
                    [title]="'COMMON.no' | translateHs" (click)="no()" data-dismiss="modal">{{'COMMON.no' |
                    translateHs }}</button>
            </div>
        </div>
    </div>
</div>